<script setup>
import {ref} from 'vue'

const props = defineProps({
    value: String
})

const html = ref('')

// created logic executed during setup initialization
if (props.value) {
    // Escape < and >.
    // Required by email_messages component for embedded email addresses e.g. <nick@omcore.net>.
    html.value = props.value.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}
</script>

<template>
    <span v-html="html"/>
</template>